module.exports = __webpack_public_path__ + "img/hand-icon.20ee76e8.svg";